import { render, staticRenderFns } from "./formLikertSkills.vue?vue&type=template&id=06655506&scoped=true&"
import script from "./formLikertSkills.vue?vue&type=script&lang=js&"
export * from "./formLikertSkills.vue?vue&type=script&lang=js&"
import style0 from "./formLikertSkills.vue?vue&type=style&index=0&id=06655506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06655506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
